import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import topTitle from '@/components/title';
import claimItem from './claimItem.vue';
import typeModel from './../typeManage/addModal.vue';
import { insuranceResource } from './../../insurance/insuranceManage/request';
import { documentResource } from './../demageManage/request';
import { claimsResource } from './../classificationManage/request';
import { claimsTypeResource, claimsTypeName } from './../typeManage/request';
import { claimsParamResource } from './../parameterManage/request';
import { claimsDetail, claimsMode, delClaimsItem } from './request';
export default {
  components: {
    topTitle,
    claimItem,
    typeModel
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        unitName: '',
        mark: '',
        insuranceId: undefined,
        type: []
      },
      mainList: [],
      claimList: [],
      claimList2: [],
      typeList: [],
      claimsTypeId: undefined,
      typeShow: false,
      documentList: [],
      disabled: false,
      claimsList: [],
      claimsParamList: [],
      claimsItem: '',
      infoEdit: false
    };
  },
  created() {
    insuranceResource({}).then(res => {
      this.mainList = res;
    });
    this.getTypeResource();
    this.getClaimsResource();
    this.getClaimsParamResource();
    this.getDocumentResource();
    if (this.id != -1) {
      this.getInfoFun();
    } else {
      this.infoEdit = true;
    }
  },
  computed: {
    dataRule() {
      return {
        insuranceId: [{
          required: true,
          message: this.$t('请选择') + this.$t('产品名称'),
          trigger: 'change'
        }],
        mark: [{
          required: true,
          message: this.$t('请输入') + this.$t('产品标识'),
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: this.$t('请输入') + this.$t('承保单位'),
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('理赔方式'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    getInfoFun() {
      claimsDetail({
        insuranceId: this.id
      }).then(res => {
        console.log(res);
        this.form.insuranceId = res.insuranceId;
        this.form.type = res.claimsMethod;
        this.claimList = res.configList;
        this.claimList2 = res.configList;
        this.markChange();
        this.disabled = false;
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getDocumentResource() {
      documentResource({}).then(res => {
        this.documentList = res;
      });
    },
    getTypeResource() {
      claimsTypeResource({}).then(res => {
        this.typeList = res;
      });
    },
    getClaimsResource() {
      claimsResource({}).then(res => {
        this.claimsList = res;
      });
    },
    getClaimsParamResource() {
      claimsParamResource({}).then(res => {
        this.claimsParamList = res;
      });
    },
    markChange() {
      let arr = this.mainList.filter(item => item.id == this.form.insuranceId);
      if (arr.length != 0) {
        this.form.mark = arr[0].mark;
        this.form.unitName = arr[0].unitName;
      }
    },
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          claimsMode({
            insuranceId: this.form.insuranceId,
            claimsMethod: this.form.type.join(','),
            actionType: this.$route.params.id == -1 ? 1 : 2
          }).then(res => {
            this.$message.success(this.$t('操作成功'));
            this.infoEdit = false;
            this.id = res.insuranceId;
          });
        }
      });
    },
    async typeChange() {
      const res = await claimsTypeName({
        claimsTypeId: this.claimsTypeId
      });
      let obj = {
        claimsTypeId: this.claimsTypeId,
        claimsTypeName: res.name,
        isEdit: true,
        config: {
          claimsDocument: [],
          claimsSort: []
        },
        claimsTypeSort: 1,
        claimsParam: []
      };
      console.log(obj, 21);
      this.claimsTypeId = undefined;
      this.disabled = true;
      this.claimList.push(obj);
    },
    addTypeFun() {
      this.$refs.typeForm.openModal('add', false, false);
    },
    typeOk(val) {
      this.getTypeResource();
      this.claimsTypeId = val.claimsTypeId;
      this.typeChange();
    },
    handleEdit(index) {
      this.claimsItem = this.claimList[index];
      this.claimList[index].isEdit = true;
      this.disabled = true;
    },
    handleCancel(index) {
      console.log(this.claimList2[index], this.claimList[index]);
      if (this.claimList[index].insuranceClaimsId) {
        claimsDetail({
          insuranceId: this.id
        }).then(res => {
          this.claimList.splice(index, 1, res.configList[index]);
        });
      } else {
        this.claimList.splice(index, 1);
      }
      this.disabled = false;
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除所选类型配置模块？'), {
        confirmButtonText: this.$t('确定')
      }).then(() => {
        delClaimsItem({
          insuranceClaimsId: val.insuranceClaimsId
        }).then(res => {
          _this.$message.success(this.$t('删除成功'));
          _this.getInfoFun();
        });
      });
    },
    filterTreeOption(input, treeNode) {
      return treeNode.data.props.title.includes(input);
    }
  }
};